import { render, staticRenderFns } from "./ProjectImage.vue?vue&type=template&id=803129e8&scoped=true&"
import script from "./ProjectImage.vue?vue&type=script&lang=js&"
export * from "./ProjectImage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectImage.vue?vue&type=style&index=0&id=803129e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803129e8",
  null
  
)

export default component.exports